<template>
    <div
        class="ListStatus"
    >
        <div class="Group">
            <Status
                icon="plus-circle"
                iconColor="green"
                :text="$tc('imports.updates.rows', numAddedRows, { count: numAddedRows })"
            />
            <Status
                icon="edit"
                iconColor="blue"
                :text="$tc('imports.updates.cells', numUpdatedCells, { count: numUpdatedCells })"
            />
        </div>
        <div class="Group">
            <Status
                icon="alert-circle"
                iconColor="red"
                :text="$tc('imports.notifications.errors', numErrors, { count: numErrors })"
            />
            <Status
                icon="alert-triangle"
                iconColor="yellow"
                :text="$tc('imports.notifications.warnings', numWarnings, { count: numWarnings })"
            />
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import Status from './Status.vue'

export default {
    name: 'ListStatus',
    components: {
        Status,
    },
    props: {
        numErrors: VueTypes.number,
        numWarnings: VueTypes.number,
        numAddedRows: VueTypes.number,
        numUpdatedCells: VueTypes.number,
    },
}
</script>
